import { FC } from 'react'
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuestion } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
import QuestionTypes from 'types/QuestionTypes';
import IQuestion from 'models/Question';

const Question:FC = () => {
  const { t } = useTranslation('common');

  const question:IQuestion = useAppSelector(selectQuestion);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady && !question.video ) return null;
  return (
    <div className="py-2 px-4">
      <p className="text-xl text-white font-bold text-center">
        {question.title}
        {question.type === QuestionTypes.MultiChoice ? (
          <span className="block text-xs text-white">
            {`( ${t('quiz.questionPage.canBeMoreThan1Answer')} )`}
          </span>
        ) : null}
      </p>
    </div>
  )
}

export default Question;
